module.exports = __webpack_public_path__ + "media/integrations/woocommerce-wordpress-32f95f15.png";